<div class="chat-clients-page">
  <div class="chat-clients-content">
    <!-- Header -->
    <div class="page-header">
      <h1 class="page-title">Your chat history</h1>
      <div class="search-row">
        <div class="search-input">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <g clip-path="url(#clip0_1_3819)">
              <path d="M14.9258 2.56259C11.5117 -0.851471 5.97656 -0.851471 2.5625 2.56259C-0.851562 5.97665 -0.851562 11.5118 2.5625 14.9259C5.53516 17.8985 10.1133 18.2813 13.5039 16.0821L17.0703 19.6485C17.543 20.1212 18.3047 20.1212 18.7773 19.6485L19.6523 18.7735C20.125 18.3009 20.125 17.5392 19.6523 17.0665L16.0859 13.5001C18.2812 10.1134 17.8984 5.53134 14.9258 2.56259ZM12.6875 12.6876C10.5117 14.8634 6.97656 14.8634 4.80078 12.6876C2.625 10.5118 2.625 6.97665 4.80078 4.80087C6.97656 2.62509 10.5117 2.62509 12.6875 4.80087C14.8633 6.97665 14.8594 10.5118 12.6875 12.6876Z" fill="#4D4D4D"/>
            </g>
            <defs>
              <clipPath id="clip0_1_3819">
                <rect width="20" height="20" fill="white"/>
              </clipPath>
            </defs>
          </svg>
          <input
            [formControl]="searchControl"
            type="text"
            placeholder="Search by name..."
            autocomplete="off"
          />
        </div>
      </div>
      <p class="page-subtitle" *ngIf="!isLoading">{{ getSubtitle() }}</p>
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-state">
      <div class="loading-spinner"></div>
      <p>Loading conversations...</p>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !isLoading" class="error-state">
      <p>{{ error }}</p>
    </div>

    <!-- Clients List -->
    <div *ngIf="!isLoading && !error" class="clients-container">
      <!-- Empty State -->
      <div *ngIf="clients.length === 0" class="empty-state">
        <div class="empty-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
          </svg>
        </div>
        <h2>No conversations yet</h2>
        <p>Start a new chat to see it here</p>
      </div>

      <!-- Clients Cards -->
      <div class="clients-grid" *ngIf="clients.length > 0">
        <div 
          *ngFor="let client of clients; trackBy: trackByClientId" 
          class="client-card"
          (click)="navigateToChat(client)"
        >
          <div class="client-avatar">
            <span class="avatar-initials">{{ getClientInitials(client) }}</span>
          </div>
          
          <div class="client-info">
            <div class="client-header">
              <h3 class="client-name">{{ getClientDisplayName(client) }}</h3>
              <span class="client-time" *ngIf="client.metadata?.last_message_at">
                {{ formatLastMessageTime(client) }}
              </span>
            </div>
            
            <p class="client-preview">{{ getLastMessagePreview(client) }}</p>
          </div>

          <div class="client-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
